export const datePicker = {
  calenderIcon: {
    alt: 'Open calender'
  },
  clearIcon: {
    alt: 'Clear date'
  }
};
